export default {
  description: 'Deleted models stay here for 7 days. After that they are removed for good.',
  search: 'Search',
  empty: 'No deleted models',
  headerName: 'Name',
  headerType: 'Type',
  headerDeletedBy: 'Deleted by',
  headerDeleted: 'Deleted',
  headerDaysLeft: 'Removed in',
  headerSource: 'Deleted from',
  daysLeft: '{count} days',
  typeAdHoc: 'Ad-Hoc',
  typeDiy: 'DIY',
  typeCustomEkrm: 'Custom EKRM',
  typeCustomReference: 'Custom Ref.',
  typeEkrm: 'EKRM',
  source: {
    modelManager: 'Model Manager',
    automaticModels: 'DIY Models',
    adHocModels: 'Ad-Hoc Models',
    modelComposer: 'Model Composer',
    manageEkrm: 'Manage EKRM'
  },
  restore: 'Restore',
  restoreTitle: 'Restore model?',
  restoreMessage: '{name} will be available again, with its plans and the access it had.',
  restoreMessageEkrm: '{name} will be available again in Manage EKRM.',
  nameConflict: 'Another model is using this name now. Choose a different one to restore it.',
  newNameLabel: 'Name',
  restoredName: '{name} (restored)',
  cancel: 'Cancel',
  close: 'Close',
  restored: '{name} was restored.',
  reportPending: 'Its model report is being generated.',
  warning: {
    'version-unlinked': 'Its place in the version family was taken, so it was restored as a model of its own.',
    'request-exists': 'Its DIY request already existed and was left as it is.',
    'ekrm-missing': 'Its EKRM no longer exists, so it will not appear in Model Composer.'
  },
  error: {
    'target-exists': 'Another model is using the same ID now, so this one cannot be restored.',
    'storage-changed': 'The model files were replaced by a newer model, so this one cannot be restored.',
    'trash-entry-not-found': 'This model is no longer in the trash.',
    'permission-denied': 'You are not allowed to restore this model.',
    unknown: 'Error restoring the model'
  }
}
